"use client";

import { useIntl } from "react-intl";

import { Fieldset } from "ui/Fieldset";
import { TypoTextSmall } from "ui/Typo";
import { cn } from "utils/helpers/cn";

export interface ERecruiterClauseProps {
    className?: string;
}

const linkClassName = "underline hover:text-f-secondary dark:hover:text-white";

export default function ERecruiterClause({ className }: ERecruiterClauseProps) {
    const { formatMessage } = useIntl();

    return (
        <Fieldset variant="grey" className={className}>
            <div className={cn("clauseContainer", "flex flex-col gap-n2")}>
                <div className="text-justify">
                    <TypoTextSmall>{formatMessage({ id: "erecruiter_clause_1" })}</TypoTextSmall>
                </div>
                <div className="text-justify">
                    <TypoTextSmall>
                        {formatMessage(
                            { id: "erecruiter_clause_2" },
                            {
                                privacyPolicy: (
                                    <a
                                        href="https://kandydat.erecruiter.pl/_files/Privacy_Policy_Candidate_Account_2022-01-20.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-test-id="privacy-policy-link"
                                        key="privacy-policy-link"
                                        className={linkClassName}
                                    >
                                        {formatMessage({ id: "privacy_policy" })}
                                    </a>
                                ),
                            },
                        )}
                    </TypoTextSmall>
                </div>

                <div className="text-justify">
                    <TypoTextSmall>
                        {formatMessage(
                            { id: "erecruiter_clause_3" },
                            {
                                candidate: (
                                    <a
                                        href="mailto:kandydat@erecruiter.pl"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-test-id="candidate-email-link"
                                        key="candidate-email-link"
                                        className={linkClassName}
                                    >
                                        kandydat@erecruiter.pl
                                    </a>
                                ),
                                dataProtectionOfficer: (
                                    <a
                                        href="mailto:iod@pracuj.pl"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-test-id="data-protection-officer-email-link"
                                        key="data-protection-officer-email-link"
                                        className={linkClassName}
                                    >
                                        iod@pracuj.pl
                                    </a>
                                ),
                                privacyPolicyCandidateAccount: (
                                    <a
                                        href="https://erecruiter.pl/_files/konto_kandydata/Polityka_Prywatnosci_Konto_Kandydata_2022-01-20.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-test-id="privacy-policy-candidate-account-link"
                                        key="privacy-policy-candidate-account-link"
                                        className={linkClassName}
                                    >
                                        {formatMessage({ id: "privacy_policy" })}
                                    </a>
                                ),
                            },
                        )}
                    </TypoTextSmall>
                </div>
            </div>
        </Fieldset>
    );
}
